import { createTheme } from '@mui/material'

// Color setup - Nautical Theme
const darkBackground = '#011627' // Deep Navy Blue
const darkPrimaryMain = '#0077B6' // Medium Blue
const darkPrimaryLight = '#00B4D8' // Bright Cyan
const darkSecondary = '#FDBE52' // Sandy Gold
const darkError = '#EF5350'
const darkWarning = '#FF9800'
const darkInfo = '#29B6F6'
const darkSuccess = '#66BB6A'

const lightBackground = '#F0F4F8' // Light Blue-Grey
const lightPrimaryMain = '#005792' // Solid Deep Blue
const lightPrimaryLight = '#0077B6' // Medium Blue
const lightSecondary = '#00B4D8' // Bright Cyan
const lightError = '#D32F2F'
const lightWarning = '#ED6C02'
const lightInfo = '#0288D1'
const lightSuccess = '#2E7D32'

export const logInBackgroundImage = `linear-gradient(to top, ${darkBackground}, ${lightPrimaryMain})`

const darkPalette = {
  background: { default: darkBackground, paper: '#02203c' },
  primary: { main: darkPrimaryMain, light: darkPrimaryLight },
  secondary: { main: darkSecondary },
  error: { main: darkError },
  warning: { main: darkWarning },
  info: { main: darkInfo },
  success: { main: darkSuccess },
  mode: 'dark',
}

const lightPalette = {
  background: { default: lightBackground },
  primary: { main: lightPrimaryMain, light: lightPrimaryLight },
  secondary: { main: lightSecondary },
  error: { main: lightError },
  warning: { main: lightWarning },
  info: { main: lightInfo },
  success: { main: lightSuccess },
  text: {
    primary: '#121212',
    secondary: '#454545',
  },
  mode: 'light',
}

const componentsOverrides = (theme) => ({
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
    },
  },
  RaAppBar: {
    styleOverrides: {
      root: {
        color: theme.palette.text.primary,
        '& .RaAppBar-toolbar': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.getContrastText(theme.palette.primary.main),
          backgroundImage: `linear-gradient(310deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
        },
      },
    },
  },
  RaSimpleFormIterator: {
    styleOverrides: {
      root: {
        '& .RaSimpleFormIterator-index': {
          display: 'block !important',
        },
        '@media (max-width: 899.95px)': {
          '& .RaSimpleFormIterator-index': {
            display: 'block !important',
          },
        },
      },
    },
  },
})

const createCustomTheme = (palette) => {
  const themeOptions = {
    palette,
    shape: { borderRadius: 8 },
    sidebar: { width: 250, closedWidth: 50 },
    spacing: 9,
    typography: {
      fontFamily: 'Gabarito, tahoma, sans-serif',
      h1: {
        fontWeight: 500,
        fontSize: '6rem',
      },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 700 },
      h4: { fontWeight: 800 },
      h5: { fontWeight: 900 },
      button: { textTransform: undefined, fontWeight: 700 },
    },
  }
  const theme = createTheme(themeOptions)
  theme.components = componentsOverrides(theme)
  return theme
}

export const customLightTheme = createCustomTheme(lightPalette)
export const customDarkTheme = createCustomTheme(darkPalette)
